var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.163 8.5H6.578a1.05 1.05 0 00-1.077.868l-1.5 10.436a1.018 1.018 0 001.078 1.071h13.584a1.016 1.016 0 001.076-1.071l-1.5-10.436a1.05 1.05 0 00-1.076-.868zM14.623 6.293A2.824 2.824 0 0011.859 4 2.822 2.822 0 009.1 6.279",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBagIcon;